
<template>
	<div>
		<div class="row mb-md-2" style="padding-top:90px;padding-bottom:30px;">
			<div class="col-sm-12 col-md-12" style="text-align:center">
				<img src="@assets/images/360mdrlogo.png" />
			</div>
		</div>
		<div class="row mb-md-2" style="padding-bottom:30px;">
			<div class="col-sm-12 col-md-12" style="text-align:center">
				<amplify-authenticator :authConfig="authConfig">
				    <!-- <amplify-sign-in slot="sign-in" username-alias="email"></amplify-sign-in> -->
					<!-- <amplify-sign-in
						:username-alias="signInConfig.usernameAlias"
						slot="sign-in"
					/>
					<amplify-sign-up
						:header-text="signUpConfig.headerText"
						:username-alias="signUpConfig.usernameAlias"
						:form-fields="signUpConfig.formFields"
						slot="sign-up"
					/> -->
				</amplify-authenticator>
				<!-- <amplify-sign-in :signInConfig="signInConfig" /> -->
			</div>
		</div>
		<div class="row mb-md-2" style="padding-bottom:30px;">
			<div class="col-sm-12 col-md-12" style="text-align:center">
				<span style="color:#afafaf">&copy; 2020 - 360 Security Group S.A.S. -&nbsp;
					<a href="https://360sec.com" class="link360">www.360sec.com</a>
				</span>
			</div>
		</div>
	</div>
</template>

<script>
import { AmplifyEventBus } from "aws-amplify-vue";
import { Auth } from "aws-amplify";
// import '@aws-amplify/ui-vue';

import axios from 'axios'

export default {
//   components: {
//     ...components
//   },
//   components: { AmplifyPlugin },
  data() {
    return {
		authConfig: {
			signInConfig: {
				isSignUpDisplayed: false
			}
		},
	}
  },
  methods: { 

  },
  mounted() {
	let that = this
	const redirect = that.$route.query.redirect

	// Extraño que no esté funcionando la generación del mensaje por la interfaz de Auth
	// El bus se probó de la siguiente forma y funciona: //AmplifyEventBus.$emit('authState', 'signedIn')
	// El workaround se hizo para poder redireccionar, utilizando Hub.listen en app.vue
	// LEL 7 Agosto 2020
	//
    AmplifyEventBus.$on("authState", eventInfo => {
      if (eventInfo === "signedIn") {
        that.$router.push({ path: "/dashboard" })
      } else if (eventInfo === "signedOut") {
        that.$router.push("/")
      }
	})

	// lastimosamente con async y await no funciona
	Auth.currentAuthenticatedUser()
		.then(() => { 
			if (redirect !== undefined) {
				that.$router.push(redirect)
			} else {
				that.$router.push({ path: "/dashboard" }) 
			}
		})
		.catch(() => { 
		 });
	
	//AmplifyEventBus.$emit('authState', 'signedIn')
  }

};
</script>

<style scoped>
	.link360 {
		color: red;
	}
</style>